var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconTools48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 24.5029V42.5029H8.5C7.80964 42.5029 7.18464 42.2231 6.73223 41.7707C6.27982 41.3183 6 40.6933 6 40.0029V24.5029H24Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 24.5029V40.0029C42 40.6933 41.7202 41.3183 41.2678 41.7707C40.8154 42.2231 40.1904 42.5029 39.5 42.5029H24V24.5029H42Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 6.50293V24.5029H6V9.00293C6 8.31257 6.27982 7.68757 6.73223 7.23516C7.18464 6.78275 7.80964 6.50293 8.5 6.50293H24Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 6.50293C40.1904 6.50293 40.8154 6.78275 41.2678 7.23516C41.7202 7.68757 42 8.31257 42 9.00293V24.5029H24V6.50293H39.5Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 15.5029H37.5",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 32.0029H37.5",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 35.0029H37.5",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1714 30.6748L17.8282 36.3317",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8286 30.6748L12.1718 36.3317",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.5029H19.5",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.0029L15 20.0029",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconTools48);
export default __webpack_public_path__ + "static/media/pictogramBeaconTools48.3ffe468822410d604eacb7be31e62b03.svg";
export { ForwardRef as ReactComponent };